import request from 'tools/request'
import {
  dispatchCompanyProfile,
  dispatchWhiteLabelTheme,
} from 'actions/whitelabel'
import { PublicCompanyProfileData, CompanyProfileState } from 'interfaces'

/**
 * Origin and prefix the platform's fallback branding is served from, per environment, so moving
 * bucket is an env change rather than a code change. It must point at a publicly readable prefix:
 * the browser fetches these directly, with no credentials.
 */
const BRANDING_ASSETS_URL = (process.env.REACT_APP_BRANDING_ASSETS_URL || '').replace(/\/+$/, '')

export const getCompanyProfile = async (dispatch: any) => {
  const companyProfile: CompanyProfileState = {
    colorCode: '#52a5ea',
    banner: `${BRANDING_ASSETS_URL}/default_banner.png`,
    logo: `${BRANDING_ASSETS_URL}/default_logo.png`,
    favicon: `${BRANDING_ASSETS_URL}/default_favicon.png`,
    ssoLoginUrl: null,
    fullData: {} as PublicCompanyProfileData,
  }
  const res = await request.get<{ companyProfile: PublicCompanyProfileData }>(
    `${process.env.REACT_APP_CARRIER_API_URL}publicresource/profile/getbycode`
  )
  const data: PublicCompanyProfileData | undefined = res?.data?.companyProfile
  let resData: CompanyProfileState | null = null
  if (data) {
    resData = {
      colorCode: data.colourCode,
      logo: `${data.logo}?${Math.floor(Math.random() * 10000000)}`,
      banner: `${data.banner}?${Math.floor(Math.random() * 10000000)}`,
      favicon: `${data.favicon}?${Math.floor(Math.random() * 10000000)}`,
      ssoLoginUrl: data.ssoLoginUrl ?? null,
      fullData: data,
    }
  }
  dispatch(dispatchCompanyProfile(resData || companyProfile))
  dispatch(
    dispatchWhiteLabelTheme({
      primary: data?.colourCode || '#52a5ea',
    })
  )
  return res
}

export const getCompanyDetails = async () => {
  const res = await request.get(`${process.env.REACT_APP_CARRIER_API_URL}companyresource/company/profileview`)
  return res?.data
}

export const getWhitelabelDetails = async () => {
  const companyId = localStorage.getItem('companyId')
  const res = await request.get(`${process.env.REACT_APP_CARRIER_API_URL}companyprofileresource/profile/get`, {
    params: {
      companyId,
    },
  })
  return res?.data
}

export const uploadCompanyFavIcon = async (formData: any) => {
  const companyId = localStorage.getItem('companyId')
  formData.append('companyId', companyId)
  const res = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL}companyprofileresource/uploadProfileFavicon`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return res?.data
}

export const uploadBannerImage = async (formData: any) => {
  const companyId = localStorage.getItem('companyId')
  formData.append('companyId', companyId)
  const res = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL}companyprofileresource/uploadProfileBanner`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return res?.data
}

export const uploadLogoImage = async (formData: any) => {
  const companyId = localStorage.getItem('companyId')
  formData.append('companyId', companyId)
  const res = await request.post(
    `${process.env.REACT_APP_CARRIER_API_URL}companyprofileresource/uploadProfileLogo`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return res?.data
}

export const updateCompanyProfile = async (payLoad: any) => {
  const companyId = localStorage.getItem('companyId')
  payLoad['companyId'] = companyId
  const res = await request.post(`${process.env.REACT_APP_CARRIER_API_URL}companyprofileresource/profile/add`, payLoad)
  return res?.data
}
